import { useState, useEffect } from "react";
import { default as ReactSelect } from "react-select";
import makeAnimated from "react-select/animated";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import emailjs from "emailjs-com";
import * as Yup from "yup";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Grid,
  Button,
  Select as SelectInput,
  Box,
  Text,
  CircularProgress,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Icon,
  IconButton,
} from "@chakra-ui/react";
import AddSection from "Components/AddSection";
import Swal from "sweetalert2";
import api from "services/api";
import MaterialTable from "material-table";
import { tableIcons } from "utils/tableIcons";
import { MdModeEdit } from "react-icons/md";
import { sortDESC } from "utils/sort";
import moment from "moment";
import { baseUrlLink } from "services/baseUrl";

interface Entidade {
  id: any;
  nm_entidade: string;
  contratoes: [
    {
      id: number;
      desc_contrato: string;
      fl_ativo: boolean;
      fl_resp_pelo_pagamento: any;
    },
  ];
  contrato_vinculado: any;
}

interface Operadora {
  id: any;
  nm_operadora: string;
  contratoes: [
    {
      id: number;
      desc_contrato: string;
      fl_ativo: boolean;
    },
  ];
}

interface Checked {
  value: number;
  label: string;
}

interface Contrato {
  id: any;
  contratoes: any;
}

interface User {
  id: number;
  email: string;
  nome: string;
  username: string;
  role: any;
  entidade?: {
    id: any;
    nm_entidade: string;
  };
  operadora?: {
    id: any;
    nm_operadora: string;
  };
  usuarios_contratoes: any;
  nr_crm: any;
  uf_crm: any;
  fl_medico: any;
}

const defaultValues = {
  email: "",
  nome: "",
  username: "",
  role: "",
  entidade: {},
  operadora: {},
};

const schema = Yup.object().shape({
  nome: Yup.string().required("Preencha o Nome"),
  email: Yup.string()
    .email("Preencha um e-mail válido")
    .required("Preencha o E-mail"),
  role: Yup.string().required("Preencha o tipo"),
});

const Usuarios = () => {
  const [entidades, setEntidades] = useState<Entidade[]>([]);
  const [contractsList, setContractsList] = useState<any>();
  const [operadoras, setOperadoras] = useState<Operadora[]>([]);
  const [contratos, setContratos] = useState<Contrato[]>([]);
  const [checkedOperadoras, setCheckedOperadoras] = useState<Checked[]>([]);
  const [checkedEntidades, setCheckedEntidades] = useState<Checked[]>([]);
  const animatedComponents = makeAnimated();
  const [users, setUsers] = useState<User[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [role, setRole] = useState<any>();
  const [changeOperadoraEntidade, setChangeOperadoraEntidade] = useState<any>();
  const [currentEditing, setCurrentEditing] = useState<null | number>(null);
  const [inputEditingName, setInputEditingName] = useState<any>();
  const [inputEditingEmailLogin, setInputEditingEmailLogin] = useState<any>();
  const [inputEditingRole, setInputEditingRole] = useState<any>();
  const [inputEditingEntidade, setInputEditingEntidade] = useState<any>();
  const [inputEditingOperadora, setInputEditingOperadora] = useState<any>();
  const [editLoading, setEditLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<User>({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const onSubmit = async (values: User) => {
    let arrayChecked: number[] = [];

    if (values.role === "operadora") {
      if (checkedOperadoras) {
        checkedOperadoras.map((item) => arrayChecked.push(item.value));
      }
    } else if (values.role === "entidade") {
      if (checkedEntidades) {
        checkedEntidades.map((item) => arrayChecked.push(item.value));
      }
    }

    const defaultPassword = `portalinter${moment().year()}`;

    const emailNotification = values.email;

    const usuarioData = {
      username: values.email,
      email: values.email,
      password: defaultPassword,
      role:
        values.role === "entidade"
          ? "4"
          : values.role === "operadora"
          ? "3"
          : values.role === "medico" && "1",
      nome: values.nome,
      fl_ativo: true,
      fl_primeiro_acesso: values.role === "medico" ? false : true,
      entidade: values.role === "entidade" ? values.entidade : null,
      operadora: values.role === "operadora" ? values.operadora : null,
      fl_medico: values.role === "medico" ? true : false,
      nr_crm: values.role === "medico" ? values.nr_crm : null,
      uf_crm: values.role === "medico" ? values.uf_crm : null,
    };

    await api
      .post("/auth/local/register", usuarioData)
      .then(async (res) => {
        const user = res.data.user;
        const usuarioContratoData = {
          contratoes: arrayChecked,
          users_permissions_user: res.data.user.id,
          fl_ativo: true,
        };
        const templateParams = {
          link: `${baseUrlLink}`,
          email: emailNotification,
          senha: defaultPassword,
        };

        try {
          await emailjs
            .send(
              // @ts-ignore
              process.env.REACT_APP_SERVICE_ID,
              process.env.REACT_APP_TEMPLATE_ID_ACESSO,
              templateParams,
              process.env.REACT_APP_USER_ID,
            )
            .then((res) => {
              console.log("EmailJS Ok!");
            });
        } catch (e) {
          console.log(e);
          Swal.fire({
            icon: "warning",
            title:
              "Erro ao enviar e-mail de acesso para o usuario! Entre em contato com o administrador do sistema",
            showConfirmButton: true,
            confirmButtonText: `Ok`,
          });
        }
        await api
          .post(`/users/${res.data.user.id}`, {
            role:
              values.role === "entidade"
                ? "4"
                : values.role === "operadora"
                ? "3"
                : values.role === "medico" && "1",
          })
          .then((res) => {})
          .catch((error) => {
            console.log("erro: ", error);
          });
        setCheckedOperadoras([]);
        setCheckedEntidades([]);
        setRole(null);
        setChangeOperadoraEntidade(null);
        // if (arrayChecked.length > 0) {
        await api
          .post("/usuarios-contratoes", usuarioContratoData)
          .then((res) => {
            setContratos([...contratos, res.data]);
            setUsers(
              [...users, { ...user, usuarios_contratoes: [res.data] }].sort(
                sortDESC,
              ),
            );
            reset();
          })
          .catch((error) => {
            console.log("erro: ", error);
            Swal.fire({
              icon: "warning",
              title:
                "Erro ao cadastrar o contrato-usuário! Entre em contato com o administrador do sistema",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          });
        // }
        Swal.fire({
          position: "top",
          icon: "success",
          title: "Usuário(a) cadastrado(a) com sucesso",
          html: `
            <p>Usuário: <b>${values.email}</p>
            </br>
            </br>
            <p><b>Um e-mail foi enviado para o usuário informando o login e senha de acesso ao Portal.</b></p>
          `,
          //<p>Senha: <b>${defaultPassword}</b></p>
          showConfirmButton: true,
        });
      })
      .catch((error) => {
        console.log("erro: ", error);
        Swal.fire({
          icon: "warning",
          title:
            "Erro ao cadastrar o(a) usuário(a)! Entre em contato com o administrador do sistema",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      });
  };

  const handleChangeCheckedOperadoras = (selectedOption: any) => {
    setCheckedOperadoras(selectedOption);
  };

  const handleChangeCheckedEntidades = (selectedOption: any) => {
    setCheckedEntidades(selectedOption);
  };

  async function handleEditUser() {
    Swal.fire({
      title: "Tem certeza que deseja editar esse(a) usuário(a)?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setEditLoading(true);
        let arrayChecked: number[] = [];

        if (inputEditingRole === "operadora") {
          if (checkedOperadoras) {
            checkedOperadoras.map((item) => arrayChecked.push(item.value));
          }
        } else if (inputEditingRole === "entidade") {
          if (checkedEntidades) {
            checkedEntidades.map((item) => arrayChecked.push(item.value));
          }
        }

        const usuarioData = {
          username: inputEditingEmailLogin,
          email: inputEditingEmailLogin,
          role:
            inputEditingRole === "entidade"
              ? 4
              : inputEditingRole === "operadora" && 3,
          nome: inputEditingName,
          entidade:
            inputEditingRole === "entidade"
              ? parseInt(inputEditingEntidade)
              : null,
          operadora:
            inputEditingRole === "operadora"
              ? parseInt(inputEditingOperadora)
              : null,
        };

        try {
          const response = await api.put(
            `/users/${currentEditing}`,
            usuarioData,
          );
          const idUsuarioContrato = response.data.usuarios_contratoes[0].id;

          const updatedUsers = users.map((user) => {
            if (user.id === currentEditing) {
              return response.data;
            }
            return user;
          });
          setUsers(updatedUsers);
          const usuarioContratoData = {
            contratoes: arrayChecked,
          };
          try {
            const response = await api.put(
              `/usuarios-contratoes/${idUsuarioContrato}`,
              usuarioContratoData,
            );
            setContratos([...contratos, response.data]);
          } catch (err) {
            console.log(err);
            setEditLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro ao editar os contratos",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          }
          setCheckedOperadoras([]);
          setCheckedEntidades([]);
          setInputEditingEmailLogin(null);
          setInputEditingRole(null);
          setInputEditingName(null);
          setInputEditingOperadora(null);
          setInputEditingEntidade(null);
          setCurrentEditing(null);
          setEditLoading(false);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Usuário(a) editado(a) com sucesso",
            showConfirmButton: false,
            timer: 3000,
          });
        } catch (err) {
          console.log(err);
          setEditLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro ao editar",
            showConfirmButton: true,
            confirmButtonText: `Ok`,
          });
        }
      }
    });
  }

  async function getOperadoras() {
    try {
      const response = await api.get("/operadoras");
      setOperadoras(response.data);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Erro ao listar as operadoras",
        showConfirmButton: true,
        confirmButtonText: `Ok`,
      });
    }
  }

  async function getEntidades() {
    try {
      const response = await api.get("/entidades");

      let array: any[] = [];

      response.data.map((doc: any) => {
        let contracts: any[] = [];
        doc.contratoes.map((doc: any) => {
          if (
            (doc.fl_extrato_boleto_nota &&
              doc.fl_ativo &&
              doc.fl_resp_pelo_pagamento === "P") ||
            (doc.fl_repasse_taxa && doc.fl_ativo) ||
            (doc.fl_extrato_boleto_nota && doc.fl_ativo)
          ) {
            contracts.push(doc);
          }
          return contracts;
        });
        doc.contrato_vinculado.map((doc: any) => {
          if (
            doc.fl_extrato_boleto_nota &&
            doc.fl_ativo &&
            doc.fl_resp_pelo_pagamento === "E"
          ) {
            contracts.push(doc);
          }
          return contracts;
        });

        array.push({ ...doc, list_contracts: contracts });
        return array;
      });

      setContractsList(array);

      setEntidades(response.data);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Erro ao listar as pessoas jurídicas",
        showConfirmButton: true,
        confirmButtonText: `Ok`,
      });
    }
  }

  async function getContratos() {
    try {
      const response = await api.get("/usuarios-contratoes");
      setContratos(response.data);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Erro ao listar os contratos",
        showConfirmButton: true,
        confirmButtonText: `Ok`,
      });
    }
  }

  async function getUsers() {
    try {
      const response = await api.get("/users?role=3&role=4");
      setUsers(response.data.sort(sortDESC));
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Erro ao listar os tipos de usuários",
        showConfirmButton: true,
        confirmButtonText: `Ok`,
      });
    }
    setPageLoading(false);
  }

  useEffect(() => {
    getOperadoras();
    getEntidades();
    getContratos();
    getUsers();
  }, []);

  if (pageLoading) {
    return (
      <Box
        as="section"
        display="flex"
        w="100%"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress isIndeterminate color="blue.200" />
      </Box>
    );
  }

  return (
    <>
      <Box
        as="section"
        display="flex"
        flexDir="column"
        w="100%"
        maxHeight="calc(100vh - 72px)"
        overflow="auto"
        pb="4"
      >
        <AddSection titleButton="Cadastrar Usuário(a)" scrollBehavior="inside">
          <form
            onSubmit={handleSubmit(onSubmit)}
            onReset={(event) => {
              event.preventDefault();
              reset(defaultValues);
            }}
          >
            <Grid gap={6}>
              <FormControl
                isInvalid={!!errors?.nome?.message}
                errortext={errors?.nome?.message}
                isRequired
              >
                <FormLabel htmlFor="nome">Nome</FormLabel>
                <Input id="nome" type="text" {...register("nome")} />
                <FormErrorMessage>{errors?.nome?.message}</FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={!!errors?.email?.message}
                errortext={errors?.email?.message}
                isRequired
              >
                <FormLabel htmlFor="email">E-mail/Login</FormLabel>
                <Input id="email" type="email" {...register("email")} />
                <FormErrorMessage>{errors?.email?.message}</FormErrorMessage>
              </FormControl>

              <FormControl
                isInvalid={!!errors?.role?.message}
                errortext={errors?.role?.message}
                isRequired
              >
                <FormLabel htmlFor="role">Tipo de usuário(a)</FormLabel>
                <SelectInput
                  placeholder="Selecione o tipo"
                  id="role"
                  type="text"
                  {...register("role")}
                  onChange={(e) => {
                    setRole(e.target.value);
                    setChangeOperadoraEntidade(null);
                  }}
                >
                  <option value="operadora">Operadora</option>
                  <option value="entidade">Pessoa Jurídica</option>
                  {/* <option value="medico">Médico</option> */}
                </SelectInput>
                <FormErrorMessage>{errors?.role?.message}</FormErrorMessage>
              </FormControl>

              {role === "medico" && (
                <>
                  <FormControl
                    isInvalid={!!errors?.nr_crm?.message}
                    errortext={errors?.nr_crm?.message}
                    isRequired={role === "medico"}
                  >
                    <FormLabel htmlFor="nr_crm">CRM</FormLabel>
                    <Input id="nr_crm" type="text" {...register("nr_crm")} />
                    <FormErrorMessage>
                      {errors?.nr_crm?.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isRequired={role === "medico"}>
                    <FormLabel htmlFor="uf_crm">Estado</FormLabel>
                    <SelectInput
                      placeholder="Selecione um estado"
                      id="uf_crm"
                      type="text"
                      {...register("uf_crm")}
                      onChange={(e) =>
                        setChangeOperadoraEntidade(e.target.value)
                      }
                    >
                      <option value="AC">Acre</option>
                      <option value="AL">Alagoas</option>
                      <option value="AP">Amapá</option>
                      <option value="AM">Amazonas</option>
                      <option value="BA">Bahia</option>
                      <option value="CE">Ceará</option>
                      <option value="DF">Distrito Federal</option>
                      <option value="ES">Espírito Santo</option>
                      <option value="GO">Goiás</option>
                      <option value="MA">Maranhão</option>
                      <option value="MT">Mato Grosso</option>
                      <option value="MS">Mato Grosso do Sul</option>
                      <option value="MG">Minas Gerais</option>
                      <option value="PA">Pará</option>
                      <option value="PB">Paraíba</option>
                      <option value="PR">Paraná</option>
                      <option value="PE">Pernambuco</option>
                      <option value="PI">Piauí</option>
                      <option value="RJ">Rio de Janeiro</option>
                      <option value="RN">Rio Grande do Norte</option>
                      <option value="RS">Rio Grande do Sul</option>
                      <option value="RO">Rondônia</option>
                      <option value="RR">Roraima</option>
                      <option value="SC">Santa Catarina</option>
                      <option value="SP">São Paulo</option>
                      <option value="SE">Sergipe</option>
                      <option value="TO">Tocantins</option>
                    </SelectInput>
                  </FormControl>
                </>
              )}

              {role === "operadora" && (
                <FormControl>
                  <FormLabel htmlFor="operadora">
                    Operadora <span style={{ color: "#E53E3E" }}>*</span>
                  </FormLabel>
                  <SelectInput
                    placeholder="Selecione uma operadora"
                    id="operadora"
                    type="text"
                    {...register("operadora")}
                    onChange={(e) => setChangeOperadoraEntidade(e.target.value)}
                  >
                    {operadoras &&
                      operadoras.map((operadora) => (
                        <option key={operadora.id} value={operadora.id}>
                          {operadora.nm_operadora}
                        </option>
                      ))}
                  </SelectInput>
                </FormControl>
              )}

              {role === "entidade" && (
                <FormControl>
                  <FormLabel htmlFor="entidade">
                    Pessoa Jurídica <span style={{ color: "#E53E3E" }}>*</span>
                  </FormLabel>
                  <SelectInput
                    placeholder="Selecione uma pessoa jurídica"
                    id="entidade"
                    type="text"
                    {...register("entidade")}
                    onChange={(e) => setChangeOperadoraEntidade(e.target.value)}
                  >
                    {entidades &&
                      entidades.map((entidade) => (
                        <option key={entidade.id} value={entidade.id}>
                          {entidade.nm_entidade}
                        </option>
                      ))}
                  </SelectInput>
                </FormControl>
              )}

              {changeOperadoraEntidade && role && role !== "medico" && (
                <Box>
                  <FormLabel htmlFor="contratos">Contratos</FormLabel>
                  <Box
                    display="flex"
                    flexDirection="column"
                    flexWrap="wrap"
                    gridColumnGap="40px"
                    gridRowGap="10px"
                  >
                    {role === "operadora" &&
                      operadoras.map(
                        (operadora) =>
                          operadora.id.toString() ===
                            changeOperadoraEntidade && (
                            <ReactSelect
                              closeMenuOnSelect={false}
                              key={operadora.id}
                              placeholder={
                                operadora.contratoes.length < 1
                                  ? "Não há contratos nesta operadora"
                                  : checkedOperadoras.length > 0
                                  ? "Selecione"
                                  : "Nenhum contrato selecionado"
                              }
                              noOptionsMessage={() => "-"}
                              value={checkedOperadoras}
                              isMulti
                              onChange={handleChangeCheckedOperadoras}
                              options={operadora.contratoes
                                .filter((contrato) => contrato.fl_ativo)
                                .map((contrato) => ({
                                  value: contrato.id,
                                  label: contrato.desc_contrato,
                                }))}
                              components={animatedComponents}
                            />
                          ),
                      )}

                    {role === "entidade" &&
                      contractsList.map(
                        (entidade: any) =>
                          entidade.id.toString() ===
                            changeOperadoraEntidade && (
                            <>
                              <ReactSelect
                                closeMenuOnSelect={false}
                                key={entidade.id}
                                placeholder={
                                  entidade.list_contracts.length < 1
                                    ? "Não há contratos nesta entidade"
                                    : checkedEntidades.length > 0
                                    ? "Selecione"
                                    : "Nenhum contrato selecionado"
                                }
                                noOptionsMessage={() => "-"}
                                value={checkedEntidades}
                                isMulti
                                onChange={handleChangeCheckedEntidades}
                                options={entidade.list_contracts.map(
                                  (entidade: any) => ({
                                    value: entidade.id,
                                    label: entidade.desc_contrato,
                                  }),
                                )}
                                components={animatedComponents}
                              />
                            </>
                          ),
                      )}
                  </Box>
                </Box>
              )}

              <Button
                isLoading={isSubmitting}
                type="submit"
                colorScheme="blue"
                disabled={
                  !!errors.nome ||
                  !!errors.email ||
                  !!errors.role ||
                  (role === "medico" && (!!errors.nr_crm || !!errors.uf_crm))
                }
              >
                Salvar
              </Button>
            </Grid>
          </form>
        </AddSection>
        <Box as="form" paddingInline="4">
          <MaterialTable
            icons={tableIcons}
            title="Usuários"
            data={users}
            localization={{
              body: {
                emptyDataSourceMessage: "Nenhum dado cadastrado.",
              },
              pagination: {
                labelDisplayedRows: "{from}-{to} de {count}",
                labelRowsSelect: "linhas",
                previousTooltip: "Página anterior",
                nextTooltip: "Próxima página",
                firstTooltip: "Primeira página",
                lastTooltip: "Última página",
              },
              toolbar: {
                searchPlaceholder: "Buscar",
              },
            }}
            options={{ emptyRowsWhenPaging: false, tableLayout: "auto" }}
            columns={[
              {
                title: "Nome",
                field: "nome",
                cellStyle: {
                  width: "19%",
                },
                render: (element) => {
                  return <Text as="p">{element.nome}</Text>;
                },
              },
              {
                title: "Email/Login",
                field: "email",
                cellStyle: {
                  width: "19%",
                },
                render: (element) => {
                  return <Text as="p">{element.email}</Text>;
                },
              },
              {
                title: "Tipo",
                field: "role.name",
                cellStyle: {
                  width: "19%",
                },
                render: (element) => {
                  return (
                    <Text>
                      {element.operadora
                        ? "Operadora"
                        : element.entidade && "Entidade"}
                    </Text>
                  );
                },
              },
              {
                title: "Nome Pessoa Jurídica/Operadora",
                cellStyle: {
                  width: "19%",
                },
                sorting: false,
                render: (element) => {
                  return (
                    <Text as="p">
                      {element.entidade
                        ? element.entidade.nm_entidade
                        : element.operadora?.nm_operadora}
                    </Text>
                  );
                },
              },
              {
                title: "Editar",
                cellStyle: {
                  width: "4%",
                },
                render: (element) => {
                  return (
                    <IconButton
                      aria-label="Editar"
                      icon={<Icon as={MdModeEdit} />}
                      fontSize="24"
                      variant="unstyled"
                      onClick={() => {
                        setCheckedOperadoras([]);
                        setCheckedEntidades([]);
                        onOpen();
                        setCurrentEditing(element.id);
                        setInputEditingName(element.nome);
                        setInputEditingEmailLogin(element.email);
                        setInputEditingRole(
                          element.entidade
                            ? "entidade"
                            : element.operadora && "operadora",
                        );
                        setInputEditingOperadora(element.operadora?.id);
                        setInputEditingEntidade(element.entidade?.id);
                        if (element.operadora) {
                          contratos.map(
                            (contrato) =>
                              contrato.id ===
                                element.usuarios_contratoes[0]?.id &&
                              setCheckedOperadoras(
                                contrato.contratoes.map((item: any) => {
                                  return {
                                    value: item.id,
                                    label: item.desc_contrato,
                                  };
                                }),
                              ),
                          );
                        }
                        if (element.entidade) {
                          contratos.map(
                            (contrato) =>
                              contrato.id ===
                                element.usuarios_contratoes[0]?.id &&
                              setCheckedEntidades(
                                contrato.contratoes.map((item: any) => {
                                  return {
                                    value: item.id,
                                    label: item.desc_contrato,
                                  };
                                }),
                              ),
                          );
                        }
                      }}
                    />
                  );
                },
              },
            ]}
          />
        </Box>
      </Box>
      {currentEditing && (
        <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
          <ModalOverlay backgroundColor="blackAlpha.500" />
          <ModalContent
            paddingBottom="4"
            marginLeft="15px"
            marginRight="15px"
            marginTop="80px"
          >
            <ModalHeader>Editar Usuário(a)</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Grid gap={6}>
                <FormControl
                  isInvalid={inputEditingName?.length < 1 ? true : false}
                  isRequired
                >
                  <FormLabel htmlFor="nome_edit">Nome</FormLabel>
                  <Input
                    id="nome_edit"
                    name="nome_edit"
                    type="text"
                    onChange={(e) => {
                      setInputEditingName(e.target.value);
                    }}
                    defaultValue={inputEditingName}
                  />
                  <FormErrorMessage>
                    Esse campo não pode ficar vazio
                  </FormErrorMessage>
                </FormControl>

                <FormControl
                  isInvalid={inputEditingEmailLogin?.length < 1 ? true : false}
                  isRequired
                >
                  <FormLabel htmlFor="email_login_edit">Email/Login</FormLabel>
                  <Input
                    id="email_login_edit"
                    name="email_login_edit"
                    type="text"
                    onChange={(e) => {
                      setInputEditingEmailLogin(e.target.value);
                    }}
                    defaultValue={inputEditingEmailLogin}
                  />
                  <FormErrorMessage>
                    Esse campo não pode ficar vazio
                  </FormErrorMessage>
                </FormControl>

                <FormControl
                  isInvalid={inputEditingRole?.length < 1 ? true : false}
                  isRequired
                >
                  <FormLabel htmlFor="tipo_usuario_edit">
                    Tipo de usuário(a)
                  </FormLabel>
                  <SelectInput
                    // placeholder="Selecione o tipo"
                    id="tipo_usuario_edit"
                    name="tipo_usuario_edit"
                    type="text"
                    onChange={(e) => {
                      setInputEditingRole(e.target.value);
                      setInputEditingOperadora("");
                      setInputEditingEntidade("");
                      setCheckedEntidades([]);
                      setCheckedOperadoras([]);
                    }}
                    value={inputEditingRole}
                  >
                    <option value="operadora">Operadora</option>
                    <option value="entidade">Pessoa Jurídica</option>
                  </SelectInput>
                  <FormErrorMessage>
                    Esse campo não pode ficar vazio
                  </FormErrorMessage>
                </FormControl>

                {inputEditingRole === "operadora" && (
                  <FormControl
                    isInvalid={inputEditingOperadora?.length < 1 ? true : false}
                    isRequired
                  >
                    <FormLabel htmlFor="operadora_edit">Operadora</FormLabel>
                    <SelectInput
                      placeholder="Selecione uma operadora"
                      id="operadora_edit"
                      name="operadora_edit"
                      type="text"
                      onChange={(e) => {
                        setInputEditingOperadora(e.target.value);
                        setCheckedOperadoras([]);
                      }}
                      value={inputEditingOperadora}
                    >
                      {operadoras &&
                        operadoras.map((operadora) => (
                          <option key={operadora.id} value={operadora.id}>
                            {operadora.nm_operadora}
                          </option>
                        ))}
                    </SelectInput>
                    <FormErrorMessage>
                      Esse campo não pode ficar vazio
                    </FormErrorMessage>
                  </FormControl>
                )}

                {inputEditingRole === "entidade" && (
                  <FormControl
                    isInvalid={inputEditingEntidade?.length < 1 ? true : false}
                    isRequired
                  >
                    <FormLabel htmlFor="entidade_edit">
                      Pessoa Jurídica
                    </FormLabel>
                    <SelectInput
                      placeholder="Selecione uma pessoa jurídica"
                      id="entidade_edit"
                      name="entidade_edit"
                      type="text"
                      onChange={(e) => {
                        setInputEditingEntidade(e.target.value);
                        setCheckedEntidades([]);
                      }}
                      value={inputEditingEntidade}
                    >
                      {entidades &&
                        entidades.map((entidade) => (
                          <option key={entidade.id} value={entidade.id}>
                            {entidade.nm_entidade}
                          </option>
                        ))}
                    </SelectInput>
                    <FormErrorMessage>
                      Esse campo não pode ficar vazio
                    </FormErrorMessage>
                  </FormControl>
                )}
                {(inputEditingOperadora || inputEditingEntidade) &&
                  inputEditingRole && (
                    <Box>
                      <FormLabel htmlFor="contratos">Contratos</FormLabel>
                      <Box
                        display="flex"
                        flexDirection="column"
                        flexWrap="wrap"
                        gridColumnGap="40px"
                        gridRowGap="10px"
                      >
                        {inputEditingRole === "operadora" &&
                          operadoras.map(
                            (operadora) =>
                              operadora.id.toString() ===
                                inputEditingOperadora.toString() && (
                                <ReactSelect
                                  closeMenuOnSelect={false}
                                  key={operadora.id}
                                  placeholder={
                                    operadora.contratoes.length < 1
                                      ? "Não há contratos nesta operadora"
                                      : checkedOperadoras.length > 0
                                      ? "Selecione"
                                      : "Nenhum contrato selecionado"
                                  }
                                  noOptionsMessage={() => "-"}
                                  value={checkedOperadoras}
                                  isMulti
                                  onChange={handleChangeCheckedOperadoras}
                                  options={operadora.contratoes
                                    .filter((contrato) => contrato.fl_ativo)
                                    .map((contrato) => ({
                                      value: contrato.id,
                                      label: contrato.desc_contrato,
                                    }))}
                                  components={animatedComponents}
                                />
                              ),
                          )}
                        {inputEditingRole === "entidade" &&
                          contractsList.map(
                            (entidade: any) =>
                              entidade.id.toString() ===
                                inputEditingEntidade.toString() && (
                                <ReactSelect
                                  closeMenuOnSelect={false}
                                  key={entidade.id}
                                  placeholder={
                                    entidade.list_contracts.length < 1
                                      ? "Não há contratos nesta entidade"
                                      : checkedEntidades.length > 0
                                      ? "Selecione"
                                      : "Nenhum contrato selecionado"
                                  }
                                  noOptionsMessage={() => "-"}
                                  value={checkedEntidades}
                                  isMulti
                                  onChange={handleChangeCheckedEntidades}
                                  options={entidade.list_contracts.map(
                                    (entidade: any) => ({
                                      value: entidade.id,
                                      label: entidade.desc_contrato,
                                    }),
                                  )}
                                  components={animatedComponents}
                                />
                              ),
                          )}
                      </Box>
                    </Box>
                  )}

                <Box
                  display="flex"
                  justifyContent="flex-end"
                  gridColumnGap="10px"
                >
                  <Button
                    width="130px"
                    isLoading={editLoading}
                    onClick={handleEditUser}
                    colorScheme="blue"
                    disabled={
                      inputEditingName?.length < 1 ||
                      inputEditingEmailLogin?.length < 1 ||
                      inputEditingRole?.length < 1 ||
                      (inputEditingRole === "operadora" &&
                        inputEditingOperadora?.length < 1) ||
                      (inputEditingRole === "entidade" &&
                        inputEditingEntidade?.length < 1)
                    }
                  >
                    Salvar
                  </Button>
                  <Button
                    width="130px"
                    colorScheme="facebook"
                    onClick={() => {
                      onClose();
                      setInputEditingName("");
                      setInputEditingEmailLogin("");
                      setInputEditingRole("");
                      setInputEditingOperadora("");
                      setInputEditingEntidade("");
                      setCurrentEditing(null);
                      setEditLoading(false);
                    }}
                  >
                    Cancelar
                  </Button>
                </Box>
              </Grid>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default Usuarios;
